import { Component, inject, input } from '@angular/core';
import { FormatService } from '../../../services';
import { SummaryItem } from '../../../models';
import { ReportValuePairsComponent } from '../report-value-pairs/report-value-pairs.component';

@Component({
  selector: 'app-report-header-details',
  templateUrl: './report-header-details.component.html',
  styleUrl: './report-header-details.component.scss',
  imports: [ReportValuePairsComponent],
})
export class ReportHeaderDetailsComponent {
  private readonly formatService = inject(FormatService);

  public readonly addressTitle = input<string>();
  public readonly address = input<string>();
  public readonly addressee = input<string>();
  public readonly additionalAddressTitle = input<string>();
  public readonly additionalAddress = input<string>();
  public readonly additionalAddressee = input<string>();
  public readonly summaryItems = input<SummaryItem[]>();

  multiLineAddress(address: string): string {
    return this.formatService.multiLineToHtml(address);
  }
}
